import React from 'react';
import { Provider } from '@rollbar/react';

// Hooks
import { useCurrentUser } from 'Shared/utils/hooks/use-current-user';

type Props = {
  children: React.ReactNode;
};

const RollbarProvider = ({ children }: Props) => {
  const { user } = useCurrentUser();
  const rollbarConfig = {
    accessToken: process.env.ROLLBAR_JS_API_KEY,
    captureUncaught: true,
    captureUnhandledRejections: true,
    payload: {
      environment: process.env.NODE_ENV,
      client: {
        javascript: {
          code_version: process.env.SOURCE_VERSION,
          source_map_enabled: true,
        },
      },
      person: user
        ? {
            id: user.id, // to match rollbar_js_embed_code in application_helper.rb, but should be deprecated
            email: user.email, // to match rollbar_js_embed_code in application_helper.rb
            slug: user.slug,
          }
        : null,
    },
  };

  return <Provider config={rollbarConfig}>{children}</Provider>;
};

export default RollbarProvider;
